<template>
  <div>
    <div class="w-full mb-4">
      <p class="text-sm text-gray-500 leading-relaxed text-justify">{{ form.description }}</p>
    </div>

    <div class="flex flex-col space-y-6">
      <div class="flex flex-col space-y-2">
        <label class="font-medium text-gray-700">{{ $t('title') }} </label>
        <b-input v-model="form.settings.title" />
      </div>
      <div class="flex flex-col space-y-2">
        <label class="font-medium text-gray-700">{{ $t('subtitle') }} </label>
        <b-input v-model="form.settings.subtitle" />
      </div>
      <div class="flex flex-col space-y-2">
        <label class="font-medium text-gray-700">{{ $t('description') }} </label>
        <b-input v-model="form.settings.description" />
      </div>
      <div class="space-y-2">
        <label class="font-medium text-gray-700">Imagen de la portada (*.jpg): </label>

        <b-field v-if="!imagePreview">
            <b-upload v-model="imageCoverFile"
              drag-drop
              expanded
              accept="image/jpg,image/jpeg,image/png"
              @input="onImageSelected"
            >
                <section class="section">
                    <div class="content has-text-centered">
                        <p>
                            <b-icon icon="upload" size="is-large" pack="fas"></b-icon>
                        </p>
                        <p>{{ $t('drag_file_or_click_select') }}</p>
                    </div>
                </section>
            </b-upload>
        </b-field>

        <div v-if="!imagePreview" class="mt-4 p-4 bg-gray-50 border border-gray-200 rounded-lg">
          <div class="flex items-center gap-2 mb-3">
            <b-icon icon="info-circle" pack="fas" size="is-small" type="is-info"></b-icon>
            <span class="text-sm font-medium text-gray-600">{{ $t('default_image') }}</span>
          </div>
          <div class="flex items-center justify-center">
            <div class="w-32 h-20 bg-white rounded-md shadow-sm border border-gray-100 overflow-hidden">
              <img class="w-full h-full object-cover" :src="fallbackImage" alt="Imagen por defecto">
            </div>
          </div>
          <p class="text-xs text-gray-500 text-center mt-3">
            {{ $t('default_cover_image_warning') }}
          </p>
        </div>

        <b-field v-if="imagePreview">
          <div class="w-full mt-4 relative flex items-center justify-center bg-gray-100 p-5 rounded">
            <img :src="imagePreview" alt="preview" style="max-width: 300px; border-radius: 8px;" />
            <div class="absolute top-0 right-0 m-2">
              <button class="delete is-small text-red-light"
                type="button"
                @click="deleteDropFile">
              </button>
            </div>
          </div>
        </b-field>

      </div>
    </div>
  </div>
</template>

<script>
import { saveConfigPage } from '../services/report-detail.service';
import { readFileAsDataURL } from '../services/helpers.service.js';

export default {

  props: {
    initialData: {
      type: Object,
      default: () => ({})
    },
    activityGroups: {
      type: Array,
      default: () => []
    },
    reportConfigs: {
      type: Object,
      default: () => ({})
    },
  },

  data() {
    return {
      form: { ...this.initialData },
      imagePreview: null,
      s3bucket: window.config.s3bucket,
      selectinImage: false,
      fallbackImage: '/images/default-cover.png',
    }
  },

  computed: {
    imageCoverFile: {
      get() {
        return this.form?.settings?.image_cover?.file || null;
      },
      set(value) {
        if (!this.form.settings) {
          this.$set(this.form, 'settings', {});
        }
        if (!this.form.settings.image_cover) {
          this.$set(this.form.settings, 'image_cover', {});
        }
        this.$set(this.form.settings.image_cover, 'file', value);
      }
    }
  },

  mounted() {
    this.initializeImageCover();
    this.loadImage();
  },

  methods: {
    initializeImageCover() {
      if (!this.form.settings) {
        this.$set(this.form, 'settings', {});
      }
      if (!this.form.settings.image_cover) {
        this.$set(this.form.settings, 'image_cover', { type: null, url: null, file: null });
      }
    },

    submit() {
      if (this.selectinImage ) {
        saveConfigPage(this.form, this.reportConfigs);
        // Emit the form data to the parent component
      }

      this.$emit('epc-save', this.form);
    },

    async loadImage() {
      try {
        this.imagePreview = await this.getSourceImage();
      } catch (e) {
        this.imagePreview = null;
      }
    },

    deleteDropFile() {
      if (this.form?.settings?.image_cover) {
        this.form.settings.image_cover.file = null;
        this.form.settings.image_cover.type = null;
        this.form.settings.image_cover.url = null;
      }
      this.imagePreview = null;
    },

    async getSourceImage() {
      const imageCover = this.form?.settings?.image_cover;

      if (!imageCover) {
        return null;
      }

      if (imageCover.type === 'url' && imageCover.url) {
        return `//${this.s3bucket}/${imageCover.url}?t=${Date.now()}`;
      }

      if (imageCover.file) {
        return await readFileAsDataURL(imageCover.file);
      }

      return null;
    },

    onImageSelected(file) {
      if (!file) {
        this.imagePreview = null;
        return;
      }
      this.selectinImage = true;

      // Inicializar image_cover si no existe
      if (!this.form.settings) {
        this.form.settings = {};
      }
      if (!this.form.settings.image_cover) {
        this.form.settings.image_cover = {};
      }

      this.form.settings.image_cover.type = 'file';

      const reader = new FileReader();
      reader.onload = (e) => {
        this.imagePreview = e.target.result;
      };
      reader.readAsDataURL(file);
    },
  },
}
</script>
